
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"oeamtc-icon__noon","width":"16","height":"16","fill":"#fff"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 5a3 3 0 103 3 3 3 0 00-3-3zm0 5a2 2 0 112-2 2 2 0 01-2 2zM4 8a.5.5 0 00-.5-.5h-2a.5.5 0 000 1h2A.5.5 0 004 8zm10.5-.5h-2a.5.5 0 000 1h2a.5.5 0 000-1zM8 4a.5.5 0 00.5-.5v-2a.5.5 0 00-1 0v2A.5.5 0 008 4zM4.46 5.17a.5.5 0 00.71-.71L3.76 3.05a.5.5 0 00-.71.71zm7.08 0L13 3.76a.5.5 0 00-.71-.71l-1.46 1.41a.5.5 0 10.71.71zM8 12a.5.5 0 00-.5.5v2a.5.5 0 001 0v-2A.5.5 0 008 12zm3.54-1.17a.5.5 0 10-.71.71L12.24 13a.5.5 0 00.71-.71zm-7.08 0l-1.41 1.41a.5.5 0 00.71.71l1.41-1.41a.5.5 0 10-.71-.71z"}})])
          )
        }
      }
    